import React from 'react';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Button } from "../../../common/styles/muiStyled";
import { EventAutocompleteOption } from "../../globalSettings/types";
import { useTranslation } from "react-i18next";

type Props = {
  disabled: boolean;
  isButtonClicked: boolean;
  onDropdownClick: () => void;
  selectedOption?: EventAutocompleteOption;
}

const EventDropdown = ({ disabled, isButtonClicked, selectedOption, onDropdownClick }: Props) => {
  const { t } = useTranslation("common");

  const getEventLabel = () => {
    if (!selectedOption) {
      return '';
    }

    if (selectedOption.label.length > 20) {
      return `${selectedOption.label.slice(0, 20)}...`;
    }
    return selectedOption.label;
  };

  return (
    <Button
      className={`event-edition-dropdown${!selectedOption?.label ? '-placeholder' : ''}`}
      disabled={disabled}
      onClick={onDropdownClick}
    >
      {selectedOption?.label ? <>{selectedOption.gbsCode}{': '}{getEventLabel()}</> : `${t("common.selectLabels.select")}...`}
      {!isButtonClicked ? <ArrowDropDownIcon data-testid="arrow-down" fontSize={"small"} className={'dropdown-icon'} />
        : <ArrowDropUpIcon data-testid="arrow-up" fontSize={"small"} className={'dropdown-icon'} />}
    </Button>
  );
}

export default EventDropdown;
